import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border: 1.3px solid #0274d2;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 12px;
  -webkit-box-shadow: 0px 2px 2px 0px #0000000a;
  box-shadow: 0px 2px 2px 0px #0000000a;

  &:last-child {
    margin-bottom: 12px;
  }

  img {
    margin-right: 8px;
  }

  span {
    color: #0274d2;
    font: 12px Montserrat;
  }

  .section {
    display: flex;
    align-items: center;
  }

  .btn-close {
    border: 0;
    background: none;
    padding-left: 10px;
  }
`;
